import { useEffect, useMemo, useState } from "react";
import MultiSelector from "../../../components/Selectors/MultiSelector";
import { Anchor, Button, Checkbox, Stack, Title, Tooltip } from "@mantine/core";
import { useLanguage } from "../../../stores/LanguageStore";
import { getBlacklists } from "../../../api/BlacklistAPI";
import { useConfigStore } from "../../../stores/ConfigStore";
import { useCampaignStore } from "../../../stores/CampaignStore";
import { parseDate } from "../../../functions/dates";

function getOptionName(option) {
  return `${option.name} ( ${option.number_of_data} )`;
}

const NewsletterBlacklistsExclusion = ({ blacklistIds, setBlacklistIds }) => {
  const lang = useLanguage((s) => s.language);
  const blacklistsStore = useConfigStore((s) => s.blacklists);
  const [blacklists, setBlacklists] = useState(
    blacklistIds?.map((listId) => {
      let list = blacklistsStore.find((x) => x.id === listId);
      if (list) {
        return {
          ...list,
          option_name: getOptionName(list),
        };
      }
      return;
    }) || [],
  );

  const options = useMemo(() => {
    return blacklistsStore
      .map((list) => ({
        ...list,
        option_name: getOptionName(list),
      }))
      .sort(
        (a, b) => blacklistIds?.includes(b.id) - blacklistIds?.includes(a.id),
      );
  }, [blacklistsStore]);

  const [loading, setLoading] = useState(false);

  const handleSelectAll = () => {
    if (blacklistIds.length === options.length) {
      setBlacklistIds([]);
    } else {
      setBlacklistIds(options.map((x) => x.id));
    }
  };

  useEffect(() => {
    setLoading(true);
    getBlacklists().finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    setBlacklists(
      blacklistIds
        ?.map((listId) => {
          let list = blacklistsStore?.find((x) => x.id === listId);
          if (list) {
            return {
              ...list,
              option_name: getOptionName(list),
            };
          }
          return;
        })
        ?.filter(Boolean) || [],
    );
  }, [blacklistsStore, blacklistIds]);

  return (
    <Stack h={"100%"} gap={"xs"}>
      <Title order={5}>{lang.campaign.exclusions.blacklist_title}</Title>

      {/* <Text size="sm">{lang.campaign.exclusions.blacklist_text}</Text> */}
      <MultiSelector
        options={options.sort(
          (a, b) => b.id - a.id,
        )}
        loading={loading}
        values={blacklists}
        onChange={(v) => setBlacklistIds(v.map((x) => x.id))}
        placeholder={lang.campaign.exclusions.search_blacklist}
        rightOptionSection={(item) => {
          return (
            <>
              <Tooltip label={lang.prm.table.columns.created_on}>
                <span style={{ fontSize: 8, whiteSpace: "nowrap" }}>
                  {parseDate(item?.created_on)}
                </span>
              </Tooltip>
              {item?.id && (
                <Anchor
                  href={`/blacklists/${item.id}`}
                  fz={10}
                  target="_blank"
                  onClick={(e) => e.stopPropagation()}
                  // opacity={0.35}
                >
                  #{item.id}
                </Anchor>
              )}
            </>
          );
        }}
        size={"md"}
        w={"100%"}
        searchable
        checkIconPosition="left"
        footer={
          <Checkbox
            label={lang.global.all_select}
            checked={blacklistIds.length === options.length}
            indeterminate={
              blacklistIds.length > 0 && blacklistIds.length < options.length
            }
            onChange={handleSelectAll}
            radius={"sm"}
          />
        }
        withClearer={false}
      />
    </Stack>
  );
};

export default NewsletterBlacklistsExclusion;
